import { render } from "./index.vue?vue&type=template&id=c64d65fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c64d65fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64d65fc"],['__file',"src/views/MyAccount/MyRedemption/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c64d65fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c64d65fc', __exports__)) {
    console.log('reload')
    api.reload('c64d65fc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c64d65fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('c64d65fc', render)
  })

}


export default __exports__